<template>
    <div class="hovered-actions">
        <CompassTooltip
            v-for="(action, actionIndex) in actions"
            :key="actionIndex"
            :content="action.textTooltip"
            :arrow="false"
        >
            <CompassIconButton
                :icon="action.icon"
                size="small"
                @click="$emit(`${action.id}-clicked`)"
            />
        </CompassTooltip>
    </div>
</template>

<script>
export default {
    props: {
        actions: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.hovered-actions {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    transition: all 0.2s linear;
    padding: 4px;
}

.copy-element:hover {
    .hovered-actions {
        opacity: 1;
    }
    .avatar-name-hovered {
        padding-right: 70px;
    }
}
</style>
